import { render } from "./table-spinner.component.vue?vue&type=template&id=752beaa8"
import script from "./table-spinner.component.vue?vue&type=script&lang=js"
export * from "./table-spinner.component.vue?vue&type=script&lang=js"

import "./table-spinner.component.vue?vue&type=style&index=0&id=752beaa8&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__